import { logger } from '@jobilla/instrumentation'

const AUTHENTICATED_TRACKED_KEY = 'cc_authenticated_tracked'

// First load of any authenticated screen is the auth signal; guard so navigation
// between screens within a session doesn't recount it.
export function trackAuthenticatedOnce(candidateId?: string): void {
	try {
		if (sessionStorage.getItem(AUTHENTICATED_TRACKED_KEY)) {
			return
		}
		sessionStorage.setItem(AUTHENTICATED_TRACKED_KEY, '1')
	} catch {
		// sessionStorage may be unavailable — still track, at worst once per load
	}

	logger.track('Candidate Center: Authenticated', { data: { candidate_id: candidateId ?? null } })
}

export function resetAuthenticatedTracking(): void {
	try {
		sessionStorage.removeItem(AUTHENTICATED_TRACKED_KEY)
	} catch {
		// sessionStorage may be unavailable — nothing to clear
	}
}
